import React from 'react';
import { RouteProps, Route, Redirect } from 'react-router-dom';
import { useAuthContext } from 'contexts/AuthProvider';

const ProtectedRoute: React.FC<RouteProps> = ({ children, ...props }) => {
  const { loading, session } = useAuthContext();

  if (loading) return <div>loading...</div>;
  if (session) return <Route {...props} children={children} />;

  return <Route {...props} children={() => <Redirect to="/login" />} />;
};

export default ProtectedRoute;
